import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { HashRouter, Route, Routes, useNavigate } from "react-router-dom";
import MainContainer from "../container";
import { getDettaglioList } from "../fetch";
import { isNotEmpty } from "../lib/utils";
import { IDettaglio, IQualita } from "../models";
import { EOptionType, IFilterOption } from "../models/utlis";
import LatestList from "./latest";
import List from "./list";
import Item from "./lotto";

export default function Router() {
  return (
    <HashRouter>
      <RouterContent />
    </HashRouter>
  );
}

function RouterContent() {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const [filters, setFilters] = useState<IFilterOption[]>([]);
  const [materialeSelected, setMaterialeSelected] = useState<
    IQualita | null | undefined
  >(undefined);
  const [dettagli, setDettagli] = useState<IDettaglio[]>([]);

  const materiali = useMemo(() => {
    const _materiali: IQualita[] = dettagli
      .map((dettaglio) => dettaglio.lotto?.qualita)
      .filter(isNotEmpty)
      .reduce(
        (prev: IQualita[], curr) =>
          !prev.find((l) => l.id === curr.id) ? [...prev, curr] : prev,
        []
      );
    const lang = i18n.language;
    return _materiali.sort((a, b) => {
      const nameA = lang === "en" && a.nomeEn ? a.nomeEn : a.nome;
      const nameB = lang === "en" && b.nomeEn ? b.nomeEn : b.nome;
      return nameA.toLowerCase() > nameB.toLowerCase() ? 1 : -1;
    });
  }, [dettagli, i18n]);

  useEffect(() => {
    let mounted = true;
    getDettaglioList().then((result) => {
      if (mounted) {
        setDettagli(result.items);
      }
    });
    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    if (!materiali.length) return;
    const hash = window.location.hash; // es: "#/?materialID=1"
    const queryString = hash.includes("?") ? hash.split("?")[1] : "";
    const params = new URLSearchParams(queryString);
    const id = params.get("materialID") ?? "";
    const materiale = materiali.find((i) => i.id === parseInt(id));
    setMaterialeSelected((prevValue) => {
      if (prevValue === undefined) {
        return materiale ?? null;
      }
    });
  }, [materiali]);
  useEffect(() => {
    setFilters((prevFilters) => {
      const _filters = prevFilters.filter(
        (opt) => opt.type !== EOptionType.qualita
      );

      if (materialeSelected?.id) {
        return [
          ..._filters,
          {
            type: EOptionType.qualita,
            numericValue: materialeSelected.id,
          },
        ];
      }

      return _filters;
    });
  }, [materialeSelected]);
  useEffect(() => {
    const hash = window.location.hash;
    const queryString = hash.includes("?") ? hash.split("?")[1] : "";
    const params = new URLSearchParams(queryString);
    const lang = params.get("lang") ?? "IT";
    i18n.changeLanguage(lang);
  }, [i18n]);
  useEffect(() => {
    const hash = window.location.hash; // es. "#/?LottoID=123"
    const queryString = hash.includes("?") ? hash.split("?")[1] : "";
    const params = new URLSearchParams(queryString);
    const lottoId = params.get("lottoID");

    if (lottoId) {
      navigate(`/${lottoId}`);
    }
  }, [navigate]);
  return (
    <Routes>
      <Route element={<MainContainer />}>
        <Route
          path="/"
          element={
            <List
              filters={filters}
              materialeSelected={materialeSelected}
              setMaterialeSelected={setMaterialeSelected}
              setFilters={setFilters}
              dettagli={dettagli}
            ></List>
          }
        ></Route>
        <Route
          path="/latest"
          element={<LatestList dettagli={dettagli}></LatestList>}
        ></Route>
        <Route path="/:id" element={<Item></Item>}></Route>
      </Route>
    </Routes>
  );
}
